module.exports = __webpack_public_path__ + "static/img/weixinqrcodebeefinfo.451a620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/weixinqrcodebeefinfo.jpg
// module id = 3Anl
// module chunks = 51